enum MenuItemsView {
  ALL = 'all',
  ITEMS = 'items',
  MODS = 'mods',
}

export default MenuItemsView;
